"use client";

import React from "react";
import { Layers, Aperture, Puzzle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const standards = [{
  title: "Legjobb Árgarancia",
  description: "Kiterjedt partnerhálózatunknak köszönhetően garantáljuk a legkedvezőbb árakat minden szálláshelyre és repülőjegyre, rejtett költségek nélkül.",
  icon: Layers
}, {
  title: "Maximális Biztonság",
  description: "Minden tranzakció és adatkezelés a legmagasabb szintű titkosítással történik. Foglaljon nyugodtan, adatai nálunk teljes biztonságban vannak.",
  icon: Aperture
}, {
  title: "24/7 Ügyfélszolgálat",
  description: "Szakértő csapatunk a nap minden percében rendelkezésére áll, legyen szó módosításról vagy váratlan helyzetek megoldásáról az út során.",
  icon: Puzzle
}];
export default function AssetQualityStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224199" id="miért-minket-válasszon" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, var(--primary) 1px, transparent 0)',
      backgroundSize: '48px 48px'
    }}></div>
      
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/10 blur-[120px] rounded-full pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight text-secondary">Miért a Sly Go-t válassza?</h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto tracking-normal">
            Prémium utazási élmények és megbízható foglalási rendszer egy helyen
          </p>
          <div className="w-24 h-1 bg-primary/20 mx-auto mt-6 rounded-full relative overflow-hidden">
             <div className="absolute inset-0 bg-primary w-1/3 animate-[pulse_3s_ease-in-out_infinite]"></div>
          </div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {standards.map((standard, i) => <div data-index={i} key={i} className="h-full">
              <Card className="h-full bg-card border-none shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 group relative overflow-hidden rounded-3xl">
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                <CardHeader className="relative pb-4">
                  {}
                  <div className="relative mb-6 inline-block">
                    <div className="absolute inset-0 bg-primary/10 blur-2xl rounded-full group-hover:bg-primary/20 transition-colors duration-500 scale-150"></div>
                    <div className="relative z-10 p-4 border border-border bg-background/80 backdrop-blur-sm rounded-2xl text-primary group-hover:scale-110 transition-all duration-300 shadow-sm">
                      <standard.icon className="w-8 h-8 stroke-[1.5]" />
                    </div>
                  </div>
                  <CardTitle className="font-default text-xl font-semibold tracking-tight text-secondary group-hover:text-primary transition-colors">
                    {standard.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-default text-base leading-relaxed text-muted-foreground group-hover:text-foreground transition-colors">
                    {standard.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}